import { useEffect, useState } from 'react';

export function useIsOnline(): boolean {
    const [isOnline, setIsOnline] = useState(() => {
        if (
            typeof window !== 'undefined' &&
            typeof window.navigator.onLine === 'boolean'
        ) {
            return window.navigator.onLine;
        }

        return true;
    });

    function handleOnline(): void {
        setIsOnline(true);
    }
    function handleOffline(): void {
        setIsOnline(false);
    }

    useEffect(() => {
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return isOnline;
}
